module.exports = __webpack_public_path__ + "static/media/assistant-background.03dd8b05.png";